<template>
  <div class="row mt-4">
    <div class="col">
      <div class="row">
        <div class="col">
          <p>
            A budget is a financial plan for your grant, itemized to show
            breakdowns of both income and expenses.
          </p>
        </div>
      </div>
      <div class="row">
        <div v-if="choosingTemplate" class="col text-left">
          <div class="text-center mb-4">
            <h5>Budget Templates</h5>
            <button
              class="btn btn-sm btn-link"
              data-toggle="modal"
              data-target="#relatedGlossaryTermsModal"
            >
              Don't know what something means?
            </button>
          </div>
          <BudgetTemplatePreview
            v-if="budgetCategories.length > 0"
            v-bind:BudgetCategories="
              budgetCategories.filter(bc => !bc.Is_Archived)
            "
            v-bind:Keywords="keywords"
            @useBudgetTemplate="useBudgetTemplate"
            @cancel="cancelChooseBudgetTemplate"
          />
        </div>
        <div v-if="!choosingTemplate" class="col">
          <div>
            <button
              class="btn btn-sm btn-link"
              data-toggle="modal"
              data-target="#relatedGlossaryTermsModal"
            >
              Don't know what something means?
            </button>
          </div>
          <button class="btn btn-link" v-on:click="choosingTemplate = true">
            Choose Template
          </button>
          <div class="card">
            <div class="card-body text-left pt-0">
              <ApplicationBudgetEditing
                v-if="budget != null"
                v-bind:Budget="budget"
                @addedApplicationBudget="applicationBudgetAdded"
                @updatedApplicationBudget="applicationBudgetUpdated"
              />
              <h6 class="mt-4" v-else>
                Choose a template to start your budget.
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RelatedGlossaryTerms v-bind:ApplicabilityFlag="4" />
  </div>
</template>

<script>
import $ from "jquery";
import BudgetTemplatePreview from "@/components/MyGrants/BudgetTemplatePreview";
import ApplicationBudgetEditing from "@/components/MyGrants/ApplicationBudgetEditing";
import RelatedGlossaryTerms from "@/modals/Glossary/RelatedGlossaryTerms";

export default {
  name: "ApplicationBudget",
  components: {
    BudgetTemplatePreview,
    ApplicationBudgetEditing,
    RelatedGlossaryTerms
  },
  props: {
    GrantApplication: Object
  },
  data() {
    return {
      budgetCategories: [],
      grantApplication: this.GrantApplication,
      grantId: this.GrantId,
      budget: this.GrantApplication.Grant_Application_Budget,
      choosingTemplate: false,
      keywords: []
    };
  },
  created() {
    this.$store.commit("updateLoading", true);
  },
  async mounted() {
    await this.$getApplicationTemplateResponseCategories(4, true).then(res => {
      res.forEach(category => {
        category.Application_Template_Responses.forEach(response => {
          response.Response = JSON.parse(response.Response);
        });
      });
      this.budgetCategories = res;
    });
    this.keywords = await this.$getApplicableKeywords(4);

    this.$store.commit("updateLoading", false);
    $(document).ready(function() {
      $('[data-toggle="popover"]').popover();
    });
  },
  methods: {
    useBudgetTemplate(template) {
      if (this.budget == null) {
        this.budget = {};
      }
      this.budget.Title = template.Response.t;
      this.budget.Subtitle = template.Response.s;
      this.budget.Budget = template.Response.r;
      this.budget.Grant_Application_Id = this.grantApplication.Grant_Application_Id;
      this.choosingTemplate = false;
    },
    cancelChooseBudgetTemplate() {
      this.choosingTemplate = false;
    },
    applicationBudgetAdded(budget) {
      this.$emit("applicationBudget", budget);
    },
    applicationBudgetUpdated(budget) {
      this.$emit("applicationBudget", budget);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
